import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";

import { LoginConfigService } from "./login.config";
import { ResetPasswordBySmsModel, ResetPasswordWithTokenModel } from "./login.model";

@Injectable({
	providedIn: "root",
})
export class LoginClient {
	constructor(
		private config: LoginConfigService,
		private httpClient: CoreHttpClient
	) {}

	resetPasswordWithToken(model: ResetPasswordWithTokenModel): Observable<object> {
		const authHeader = model.authToken ? { "x-auth-token": model.authToken } : undefined;
		return this.httpClient.patch({
			url: this.config.getChangePasswordTokenEndpoint(),
			data: {
				newPassword: model.newPassword,
			},
			searchParams: {
				forgotPasswordToken: model.token,
			},
			headers: authHeader,
		});
	}

	resetPasswordByEmail(email: string): Observable<object> {
		return this.httpClient.post({
			url: this.config.getResetPasswordByEmailEndpoint(),
			data: {
				emailAddress: email,
			},
		});
	}

	resetPasswordBySms(model: ResetPasswordBySmsModel): Observable<object> {
		return this.httpClient.post({
			url: this.config.getResetPasswordBySmsEndpoint(),
			data: {
				ResetType: "SMS",
				Identifier: model.username,
				NationalId: model.nationalIdNumber,
				PhoneExtension: `+${model.phoneExtension}`,
				PhoneNumber: model.phoneNumber,
			},
		});
	}

	resetPasswordByEmailAndSecurityQuestion(
		email: string,
		securityQuestion: string,
		answer: string
	): Observable<object> {
		return this.httpClient.post({
			url: this.config.getResetPasswordByEmailEndpoint(),
			data: {
				identifier: email,
				securityQuestion,
				answer,
			},
		});
	}
}
